/**
 * Category Tag Filter Component
 * Handles dropdown-based filtering using categorized tags
 */
class CategoryFilterComponent extends HTMLElement {
  constructor() {
    super();
    this.blogHandle = this.getAttribute('blog-handle');
    this.currentFilter = this.getAttribute('current-filter') || '';
    this.separator = this.getAttribute('separator') || '#';
    
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const selects = this.querySelectorAll('.blog-filter__select');
    selects.forEach(select => {
      select.addEventListener('change', (event) => {
        this.handleFilterChange(event);
      });
    });

    const clearButton = this.querySelector('.blog-filter__clear-all');
    if (clearButton) {
      clearButton.addEventListener('click', () => {
        this.clearFilters();
      });
    }
  }

  /**
   * @param {Event} event
   */
  handleFilterChange(event) {
    const select = /** @type {HTMLSelectElement} */ (event.target);
    const selectedValue = select.value;
    
    if (selectedValue) {
      this.navigateToFilter(selectedValue);
    } else {
      this.clearFilters();
    }
  }

  /**
   * @param {string} filterValue
   */
  navigateToFilter(filterValue) {
    const url = `/blogs/${this.blogHandle}/tagged/${filterValue}`;
    window.location.href = url;
  }

  clearFilters() {
    const url = `/blogs/${this.blogHandle}`;
    window.location.href = url;
  }
}

// Register custom element
if (!customElements.get('category-filter-component')) {
  customElements.define('category-filter-component', CategoryFilterComponent);
}

export default CategoryFilterComponent;